import { Base64 } from 'js-base64';

const cleanMessageContent = (content) => {
  // Créer un élément div temporaire pour parser le HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;

  // Supprimer les images
  const images = tempDiv.getElementsByTagName('img');
  while (images.length > 0) {
    images[0].parentNode.removeChild(images[0]);
  }

  // Récupérer le texte brut
  let text = tempDiv.textContent || tempDiv.innerText;

  // Nettoyer les espaces multiples et retours à la ligne
  text = text.replace(/\s+/g, ' ').trim();

  return text;
};

// formatage des images
const formatMessagesForExport = (ticket) => {
  const messages = ticket?.messages?.map((message) => ({
    id: message._id,
    from: message.from,
    to: message.to,
    subject: message.subject,
    sentAt: message.sentAt,
    type: message.type.name,
    content: cleanMessageContent(
      Base64.decode(message.htmlBody || message.txtBody)
    ),
    attachments: message.attachments?.map((att) => ({
      name: att.name,
      mimeType: att.mimeType,
      size: att.size,
    })),
  }));

  return {
    ticketReference: ticket.reference,
    orderReference: ticket?.order?.reference,
    exportedAt: new Date().toISOString(),
    messages: messages,
  };
};

// exportation des messages dans un fichier json
export const downloadTicketMessages = (ticket) => {
  const data = formatMessagesForExport(ticket);
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `ticket-${ticket.reference}-messages.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
